import { loadTheme } from 'owa-theme';
import { orchestrator } from 'satcheljs';
import { refreshAssignedColorScheme } from '../utils/CalendarColorResolver';
import { initializeDefaultColorSchemes } from '../utils/CalendarColorSchemes';
import { getStore } from '../store/store';
import { CalendarId } from 'owa-calendar-cache';

orchestrator(loadTheme, () => {
    // When we go to darkmode, reinitialize default color schemes
    initializeDefaultColorSchemes();
    getStore().assignedCalendarColors.forEach((colorScheme, calendarId) => {
        refreshAssignedColorScheme({ id: calendarId } as CalendarId);
    });
});
